import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from './data/Constants';
import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';
import deTranslations from './locales/de.json';
import itTranslations from './locales/it.json';
import frTranslations from './locales/fr.json';

// Supported languages
export const supportedLanguages = SUPPORTED_LANGUAGES;

const normalizeLanguage = (lang) =>
    lang && supportedLanguages.includes(lang) ? lang : null;

// Detect language from the current URL: /blog/<lang>/...
const getLanguageFromPath = () => {
    const pathSegments = window.location.pathname
        .split('/')
        .filter((segment) => segment);

    // Remove "blog" prefix if present in the path
    const firstSegment = pathSegments[0];
    const languageCandidate =
        firstSegment === 'blog' ? pathSegments[1] : firstSegment;

    if (languageCandidate && supportedLanguages.includes(languageCandidate)) {
        return languageCandidate;
    }

    return null;
};

// Function to detect browser language
const detectBrowserLanguage = () => {
    const browserLang = navigator.language || navigator.userLanguage;
    const browserLangs = navigator.languages || [browserLang];

    const getLanguageCode = (lang) => {
        if (!lang) return null;
        return lang.split('-')[0].toLowerCase();
    };

    for (let lang of browserLangs) {
        const langCode = getLanguageCode(lang);
        if (langCode && supportedLanguages.includes(langCode)) {
            return langCode;
        }
    }

    return 'en';
};

// Order of preference: URL language > saved language > browser language
const savedLanguage = localStorage.getItem('i18nextLng');
const urlLanguage = normalizeLanguage(getLanguageFromPath());
const detectedLanguage = detectBrowserLanguage();
const normalizedSaved = normalizeLanguage(savedLanguage);
export const initialLanguage =
    urlLanguage || normalizedSaved || detectedLanguage;

// Save detected language to localStorage if it's the first visit
if (!savedLanguage && initialLanguage) {
    localStorage.setItem('i18nextLng', initialLanguage);
}

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: enTranslations,
        },
        es: {
            translation: esTranslations,
        },
        de: {
            translation: deTranslations,
        },
        it: {
            translation: itTranslations,
        },
        fr: {
            translation: frTranslations,
        },
    },
    lng: initialLanguage,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false, // React already escapes values
    },
});

// Ensure language changes are saved to localStorage
i18n.on('languageChanged', (lng) => {
    localStorage.setItem('i18nextLng', lng);
});

export default i18n;
